__turbopack_context__.v({
  "controls": "CWOLJW_controls",
  "frame": "CWOLJW_frame",
  "root": "CWOLJW_root",
});
